module.exports = __webpack_public_path__ + "static/media/bd.274a6925.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bd.svg
// module id = 2043
// module chunks = 0